class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  getDrawer() {
    return this.drawer || document.querySelector('cart-drawer');
  }

  isDrawerOpenish(drawer) {
    const d = drawer || this.getDrawer();
    if (d?.state === 'open' || d?.state === 'opening') return true;
    const details =
      d?.querySelector?.('details.cart-drawer-container') ||
      d?.querySelector?.('details') ||
      document.querySelector('cart-drawer details');
    return !!(
      details?.hasAttribute('open') ||
      document.body.classList.contains('mini-cart--open') ||
      document.body.classList.contains('mini-cart--opening')
    );
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // Already hydrated (e.g. after add-to-cart section render) — don't wipe open coupon UI
    if (this.querySelector('[data-myd-cart]')) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      const drawer = this.getDrawer();
      if (drawer && typeof drawer.contentReplaced === 'function') {
        drawer.contentReplaced({ wasOpen: this.isDrawerOpenish(drawer) });
      } else if (drawer && typeof drawer.syncOpenState === 'function') {
        drawer.syncOpenState();
      }
      return;
    }

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const drawer = this.getDrawer();
        const wasOpen = this.isDrawerOpenish(drawer);

        document.getElementById('mini-cart').innerHTML = this.getSectionInnerHTML(
          html,
          '.shopify-section'
        );

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        if (drawer && typeof drawer.contentReplaced === 'function') {
          drawer.contentReplaced({ wasOpen });
        } else if (wasOpen && drawer && !drawer._userClosed) {
          if (typeof drawer.syncOpenState === 'function') {
            drawer.syncOpenState({ graceMs: 450 });
          } else if (typeof drawer.openMenuDrawer === 'function') {
            drawer.openMenuDrawer(drawer.querySelector('summary'));
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const drawer = this.getDrawer();
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open({ summary: drawer.querySelector('summary') });
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    const detailsElement =
      drawer.querySelector('details.cart-drawer-container') || drawer.querySelector('details');
    if (!detailsElement) return;

    if (
      detailsElement.hasAttribute('open') &&
      (document.body.classList.contains('mini-cart--open') ||
        document.body.classList.contains('mini-cart--opening'))
    ) {
      document.body.classList.add('mini-cart--open');
      document.body.classList.remove('mini-cart--closing');
      detailsElement.classList.add('menu-opening');
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    const summary = detailsElement.querySelector('summary');
    if (typeof drawer.openMenuDrawer === 'function') {
      drawer.openMenuDrawer(summary);
    } else {
      detailsElement.setAttribute('open', '');
      detailsElement.classList.add('menu-opening');
      document.body.classList.add('mini-cart--open');
    }

    document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
  }

  /**
   * Update cart DOM from section HTML. Does NOT force-open.
   * Reasserts visibility via contentReplaced when the drawer was already open.
   */
  updateContents(parsedState) {
    this.productId = parsedState.id;

    const drawer = this.getDrawer();
    const wasOpen = this.isDrawerOpenish(drawer);

    // Keep cart-scoped "Select your fit" alive across section HTML swaps
    const qa =
      this.querySelector('myd-search-quick-add') ||
      document.querySelector('myd-search-quick-add.myd-search-qa--cart');
    const qaWasInCart =
      qa && (qa.parentElement === this || qa.classList.contains('myd-search-qa--cart'));
    if (qaWasInCart && qa) {
      document.body.appendChild(qa);
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml =
        parsedState.sections?.[section.section] || parsedState.sections?.[section.id];
      const el = document.getElementById(section.id);
      if (!el || !sectionHtml) return;
      try {
        el.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      } catch (e) {
        console.error('mini-cart section render failed', section.id, e);
      }
    });

    if (qaWasInCart && qa && this.isConnected) {
      this.appendChild(qa);
      qa.classList.add('myd-search-qa--cart');
      this.classList.add('myd-cart--qa-open');
      if (typeof qa.pinToCartPanel === 'function') qa.pinToCartPanel(this);
    }

    if (drawer && typeof drawer.contentReplaced === 'function') {
      drawer.contentReplaced({ wasOpen });
    }

    return wasOpen;
  }

  /**
   * ATC / gift-wrap path: update DOM then open the drawer.
   */
  renderContents(parsedState) {
    this.updateContents(parsedState);
    this.open();
  }

  getSectionsToRender() {
    const cartSection =
      this.dataset.section ||
      document.getElementById('mini-cart')?.dataset?.section ||
      'mini-cart';
    return [
      {
        id: 'mini-cart',
        section: cartSection,
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector) || doc.body;
    return node ? node.innerHTML : html;
  }
}

customElements.define('mini-cart', MiniCart);
